import { render, staticRenderFns } from "./paasInitRequest.vue?vue&type=template&id=019d2a81&scoped=true&"
import script from "./paasInitRequest.vue?vue&type=script&lang=js&"
export * from "./paasInitRequest.vue?vue&type=script&lang=js&"
import style0 from "./paasInitRequest.vue?vue&type=style&index=0&id=019d2a81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d2a81",
  null
  
)

export default component.exports